import { HttpClient } from "./HttpClient";
import Fernet from "fernet";

const FERNET_KEY = "HVDmbZ-JoHdj8MSu2lsDUPnfNgjUnHjhrH5QGhDry1Q=";
const PUBLIC_API_KEY = "IVT_H8Lw9zEUyc2hn_P39XAfSPuJ0Y3jrLqR8Rw6b6Y=";

export const GetAnnouncements = async (params = {}) => {
  try {
    const secret = new Fernet.Secret(FERNET_KEY);
    const token = new Fernet.Token({
      secret: secret,
      ttl: 0,
    });
    const encryptedKey = token.encode(PUBLIC_API_KEY);
    const response = await HttpClient.get(
      `https://enfinicore-dev-be-fvdgftefefe3atcr.eastus2-01.azurewebsites.net/api/announcement/public`,
      {
        params,
        headers: {
          "x-api-key": encryptedKey,
        },
      }
    );

    return {
      success: true,
      data: response.data.data || [],
      total: response.data.total || 0,
      limit: response.data.limit || 10,
      offset: response.data.offset || 0,
      page: response.data.page || 1,
      total_pages: response.data.total_pages || 0,
    };
  } catch (error) {
    console.error(
      "Error fetching announcements:",
      error?.response?.data?.detail || error?.message,
      error
    );
    return {
      success: false,
      message:
        error?.response?.data?.detail || "Failed to fetch announcements.",
      data: [],
      total: 0,
      page: 1,
      total_pages: 0,
    };
  }
};
